import { LESSON_TYPES } from 'constants/common';

export const LESSON_TYPE_ICON_SIZE = 9;

const LESSON_TYPE_ICON_NAMES: Record<string, string> = {
  [LESSON_TYPES.FIGMA_LESSON]: 'practice',
  [LESSON_TYPES.THEORY_LESSON]: 'theory',
  [LESSON_TYPES.QUIZ]: 'quiz',
  [LESSON_TYPES.CONNECTION_QUIZ]: 'connectionQuiz',
  [LESSON_TYPES.TWO_COLUMNS_LESSON]: 'twoColumns',
  [LESSON_TYPES.DIFFERENCE_LESSON]: 'difference',
  [LESSON_TYPES.COLOR_MATCH_LESSON]: 'colorMatch',
};

const readNonEmptyString = (value: unknown): string | null =>
  typeof value === 'string' && value.trim().length > 0 ? value.trim() : null;

export const getLessonTypeIconName = (lessonType: string | null | undefined): string | null => {
  if (!lessonType) {
    return null;
  }

  return LESSON_TYPE_ICON_NAMES[lessonType] ?? null;
};

export const resolveLessonTypeFromProperties = (
  properties?: Record<string, unknown>,
): string | null =>
  readNonEmptyString(properties?.lesson_type) ??
  readNonEmptyString(properties?.lessonType);

const LESSON_RELATED_EVENT_KEYS = new Set([
  'lesson_viewed',
  'lesson_started',
  'lesson_completed',
  'lesson_abandoned',
  'lesson_rated',
  'task_started',
  'task_completed',
  'task_skipped',
  'task_answered',
  'lesson_task_answered',
  'lesson_exited',
  'lesson_navigated',
  'activation_completed',
]);

export const isLessonRelatedEventKey = (translationKey: string): boolean =>
  LESSON_RELATED_EVENT_KEYS.has(translationKey);

/** Trainer/catalog events that carry lesson_name in properties. */
export const hasLessonNameInProperties = (
  properties?: Record<string, unknown>,
): boolean => Boolean(readNonEmptyString(properties?.lesson_name));
